import { Link } from 'react-router'

import { Card } from '../ui'
import type { PendingJob } from '../../lib/pendingJob'
import { pendingSentence } from './pendingSentence'

/**
 * An upload this browser started, and the screen that owns it.
 *
 * ── WHAT HOME CANNOT KNOW, AND THEREFORE DOES NOT SAY ───────────────────────
 *
 * The pointer is a localStorage record written by Record when a job is
 * submitted. It can outlive its job — the user left Record mid-run, the tab was
 * closed, the job finished while nothing was watching — so Home cannot say the
 * upload is "processing", "in progress" or "nearly done". It can say when it
 * was started, and that Record is the screen that follows it to its result.
 *
 * ── AND WHAT IT MUST NOT DO ─────────────────────────────────────────────────
 *
 * It never polls and never clears the pointer. Record owns both: a second
 * poller would double the job traffic and race the first, and clearing from
 * here would delete the resume pointer of a job Record is still watching.
 *
 * `formatDateTime`, not `formatSessionDate`: `startedAt` is an instant, not a
 * calendar date.
 */
export function PendingUploadCard({ pending }: { pending: PendingJob }) {
  return (
    <Card eyebrow="Upload started">
      <p className="product-empty__body">
        {pendingSentence(pending)}
      </p>
      <Link className="btn btn--ghost btn--sm" to="/record">
        Open Record
      </Link>
    </Card>
  )
}
